import React, {useEffect, useState} from 'react';
import Player from "../../../../components/Player";
import Slider from "rc-slider";
import {Button} from "../../../../components/Button";
import "./CoverFromPlayer.scss"
//import {updateCoverVideoFfmpeg} from "../../../../../creators/media";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {MEDIA_KEY, MEDIAS_KEY, updateCoverVideoFfmpeg} from "../../../../../api/public-voissa/medias";
import {toastError} from "../../../../../libs/toast";
import {MEDIA} from "../../../../../const/toasts";


const CoverFromPlayer = ({
        currentMedia = {},
        handleClose = () =>{},
        goBack = () =>{}
    }) => {
    const queryClient = useQueryClient();
    const [pos, setPos] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [internalPlayer, setInternalPlayer] = useState(null);

    const {
        mutate : mutateCoverMedia,
    } = useMutation((data) => updateCoverVideoFfmpeg(currentMedia._id, data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([MEDIAS_KEY]);
            await queryClient.invalidateQueries([MEDIA_KEY, currentMedia._id]);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.UPDATE);
        }
    });

    function setRefPlayer(player) {
        if(player){
            setInternalPlayer(player);
            setIsLoading(true);
            player.addEventListener('play', ()=>{
                player.pause();
            });
        }
    }

    function handlePosition(pos){
        if(internalPlayer){
            setPos(pos);
            let duration = internalPlayer.duration;
            let newTime = duration * pos / 100;
            internalPlayer.currentTime = newTime;
        }
    }

    function onSubmit(){
        if(internalPlayer){
            let currentTime = internalPlayer.currentTime;
            currentTime = parseInt(currentTime * 1000);
            //call l'api
            mutateCoverMedia({currentTime});
            handleClose();
        }
    }

    useEffect(() => {
        return () => {
            if(internalPlayer){
                internalPlayer.removeEventListener('play', ()=>{
                    internalPlayer.pause();
                });
            }
        };
    }, [internalPlayer]);

    return (
        <div id="cover-from-player">
            <Player media={currentMedia} setRefPlayer={setRefPlayer} controls={false} muteStrength={true} />
            {internalPlayer ?
                <div className={"controls"}>
                    <Slider
                        min={0}
                        max={100}
                        step={1}
                        defaultValue={pos}
                        value={pos}
                        onChange={(pos)=> handlePosition(pos)}
                    />
                    <div className={"btn-group"}>
                        <Button size={"small"}
                                btnStyle={"grey"}
                                onClick={() => goBack()}
                                content={"Annuler"}
                        />
                        <Button size={"small"}
                                btnStyle={"primary-reverse"}
                                className={"ml-8"}
                                onClick={() => onSubmit()}
                                content={"Utiliser cette image en couverture"}
                        />
                    </div>

                </div>
                : <div className={"btn-group"}>
                    <p className={"text-danger"}>{isLoading ? "Impossible de charger la vidéo" : ""}</p>
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => goBack()}
                            content={"Annuler"}
                    />
                </div>}
        </div>
    )
};

export default CoverFromPlayer;